import { combineReducers } from "redux";
import { sessionData } from "./reducer";

export default combineReducers({
  sessionData
});
